import { DeviceType, FIRMWARE_HARDWARE, FirmwareType } from '@ixicare/resources';
import { t } from '~i18n';

// Gateways take two firmwares, so the device type alone does not tell them apart.
const isGatewayFirmware = (type: FirmwareType) =>
  FIRMWARE_HARDWARE[type]?.deviceTypes.includes(DeviceType.GATEWAY) ?? false;

// "ixi Lite, Button" for device firmware, "Gateway BLE" for gateways, the raw type otherwise.
export const firmwareDevicesLabel = (type: FirmwareType): string => {
  const hardware = FIRMWARE_HARDWARE[type];
  if (!hardware) return type;
  if (isGatewayFirmware(type)) return hardware.chip;
  return hardware.deviceTypes.map((deviceType) => t(`device.types.${deviceType.toLowerCase()}`)).join(', ');
};

// "B7 · hw 1.1.0 · MINEW_B7_BLE": what TechOps recognises the firmware by.
export const firmwareHardwareLabel = (type: FirmwareType): string => {
  const hardware = FIRMWARE_HARDWARE[type];
  const chip = isGatewayFirmware(type) ? undefined : hardware?.chip;
  return [chip, hardware?.hwVersion && `hw ${hardware.hwVersion}`, type].filter(Boolean).join(' · ');
};

export const firmwareTypeOptionLabel = (type: FirmwareType): string => {
  const chip = FIRMWARE_HARDWARE[type]?.chip;
  return chip && !isGatewayFirmware(type) ? `${firmwareDevicesLabel(type)} (${chip})` : firmwareDevicesLabel(type);
};

// "tequinity/2.2.7" -> "2.2.7", so the reported version compares to an uploaded one.
export const plainVersion = (version?: string) => version?.match(/\d+(\.\d+)+/)?.[0];
